import { Component, OnDestroy, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { ItemService } from '@services/item.service';
import { RoleManagementService } from '@services/role.management.service';
import { Subject, Subscription } from 'rxjs';
import { CreateNewItemComponent } from '../create-new-item/create-new-item.component';
import { WebErrorService } from '@services/webError.service';
import { TranslateService } from '@ngx-translate/core';
import { ScoringTypeEnum, ScoringTypeName1, ScoringTypeNameEnum } from 'src/app/shared/config/questions.config';
import { DelMessageComponent } from 'src/app/shared/del-message/del-message.component';
import { takeUntil } from 'rxjs/operators';
import { NotificationService } from '@services/notification.service';
import { videoAssetGroups } from '@configs/videoTitles';
export interface UserData {
  itemname: string;
  itemdescription: string;
  tags: any;
  isItemTag: boolean;
  updatedDate: any;
  updatedBy: string;
}

@Component({
  selector: 'app-item-landing',
  templateUrl: './item-landing.component.html',
  styleUrls: ['./item-landing.component.scss']
})
export class ItemLandingComponent implements OnDestroy {

  dataSource: MatTableDataSource<UserData>;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) set content(paginator: MatPaginator) {
    if(this.items){
      this.items.paginator = paginator;
    }
  }
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('deleteError') private deleteError: TemplateRef<any>;
  globalCollectionId: any;
  globalCollectionUUID: any;
  itemSubscription: Subscription;
  itemFilterSubscription: Subscription;
  activeRouteSubscription: Subscription;

  items: any;
  itemId: any;
  itemName = '';
  itemDescription = '';
  itemStatus: number = 0;
  tag = null;
  tagInput: string = '';
  isNoItems = false;
  isItemDescended = true;
  ScoringTypeEnum = ScoringTypeEnum;
  ScoringTypeNameEnum = ScoringTypeNameEnum;
  ScoringTypeName1 = ScoringTypeName1;
  statusArray: any;
  displayedColumns: string[] = ['itemBankName', 'questionTypes','scoringType', 'itemStatus', 'updated', 'tags', 'action'];
  private unsubscribe: Subject<void> = new Subject<void>();
  langCode : string;
  isSearched: boolean = false;
  currentUserData: any;
  isHidden = false;
  videoLinks: any;
  videoAssetGroups = videoAssetGroups;
  hoverVideoApiCall: boolean = false;
  constructor(
    private router: Router,
    public dialog: MatDialog,
    private itemService: ItemService,
    public roleSer: RoleManagementService,
    private activatedRoute: ActivatedRoute,
    private webErrorService: WebErrorService,
    public translate: TranslateService,
    public notificationSer: NotificationService
  ) {
    this.currentUserData = JSON.parse(sessionStorage.currentUser);
    this.langCode = localStorage.getItem('language');
    this.itemService.getQuestionSubtypes().subscribe((Que) => {
      Que.sort((a, b) => (a.questionTypeId - b.questionTypeId));
      sessionStorage.setItem('QuestionSubtypes', JSON.stringify(Que))
    });
    this.itemService.getQuestionTypes().subscribe((Que) => {
      Que.items.sort((a, b) => (a.questionTypeId - b.questionTypeId));
      sessionStorage.setItem('Questiontypes', JSON.stringify(Que))
    });
    this.itemService.getItemStatus().subscribe(status => { this.statusArray = status.items;
      this.itemService.itemStatusList.next(this.statusArray); });

    this.activeRouteSubscription = this.activatedRoute.parent.paramMap.subscribe(params => {
      this.globalCollectionId = params.get('id');
      if (this.globalCollectionId) {
        this.itemService.getItem(this.globalCollectionId)
          .subscribe(
            (resData) => {
              this.items = resData?.data;
              this.itemName = '';
              this.itemDescription = '';
              this.tag = '';
              this.itemStatus = 0;

              if (this.items?.length < 1) {
                this.isNoItems = true;
              }
              else {
                this.isNoItems = false;
                this.isSearched = false;
                this.items.sort((a, b) => new Date(b.updated).getTime() - new Date(a.updated).getTime());
                this.items.forEach(d => {d.questionTypes = d.questionTypes != null ? d.questionTypes[0].replaceAll(/\r/g, ' '): ''})

                this.items = new MatTableDataSource(this.items);
                this.items.sort = this.sort;
                this.items.paginator = this.paginator;
                this.itemId = this.items?.itemBankId;
                this.globalCollectionUUID = JSON.parse(sessionStorage.defaultcollectionuuid);
              }
              this.setPaginator();
            }, (error: any) => {
              this.webErrorService.handleAPIErrors(error);
            });
      }
    });
  }

  ngAfterViewInit(): void {
    document.onclick = (args: any) : void => {
      if(args.target.className != 'trainingIcon') {
        this.isHidden = false;
      }
    }
  }

  onTrainingIcon(groupName) {
    this.isHidden = true;
    if (!this.hoverVideoApiCall) {
      this.itemService.videoTutorial(groupName).subscribe(video => {
        this.videoLinks = video.data;
        this.hoverVideoApiCall = true;
      });
    }
  }

  open_in_new_window(features, link) {
    var new_window;
    if(features !== undefined && features !== '') {
      new_window = window.open('', '_blank', features);
    }
    else {
      new_window = window.open('', '_blank');
    }

    let video = '<video controls controlsList="nodownload" style="width: 100%; height: 100vh;"><source src="' + link + '" type="video/mp4" /></video>'

    if(link !== null && link !== '') {
      new_window.document.write('<!doctype html><html><head><title>Video Player</title><meta charset="UTF-8" /></head><body style="padding: 0; margin: 0;" oncontextmenu="return false">' + video + '</body></html>');
    }
  }

  setPaginator(): void {
    this.items.paginator = this.paginator;
    this.items.sort = this.sort;

    // ------Set translation for pagination------
    if(this.items.paginator) {
      this.translate.stream([
        'items.pagination.pageLabel',
        'items.pagination.firstPage',
        'items.pagination.lastPage',
        'items.pagination.nextPage',
        'items.pagination.prevPage'
      ]).pipe(takeUntil(this.unsubscribe)).subscribe(translation => {
          this.items.paginator._intl.itemsPerPageLabel = translation['items.pagination.pageLabel'];
          this.items.paginator._intl.firstPageLabel = translation['items.pagination.firstPage'];
          this.items.paginator._intl.lastPageLabel = translation['items.pagination.lastPage'];
          this.items.paginator._intl.nextPageLabel = translation['items.pagination.nextPage'];
          this.items.paginator._intl.previousPageLabel = translation['items.pagination.prevPage'];

          this.items.paginator._intl.changes.next();
      });
    }
  }

  getItemsInCollection() {
    this.itemService.getItem(this.globalCollectionId).subscribe(
      (resData) => {
        this.items = resData?.data;
        if (this.items?.length == 0) { this.isNoItems = true; }
        else {
          this.isNoItems = false;
          this.items.sort((a, b) => new Date(b.updated).getTime() - new Date(a.updated).getTime());
          this.items.forEach(d => { d.questionTypes = d.questionTypes != null ? d.questionTypes[0].replaceAll(/\r/g, ' '): ''})

          this.items = new MatTableDataSource(this.items);
          this.items.sort = this.sort;

          this.itemId = this.items?.itemBankId;
          this.globalCollectionUUID = JSON.parse(sessionStorage.defaultcollectionuuid);
        }
        this.setPaginator();
      }, (error: any) => {
        this.webErrorService.handleAPIErrors(error);
      });
  }

  openNewItemDialog(): void {
    if(this.roleSer.accessData && this.roleSer.accessData.insertAllowed || this.roleSer.accessData.updateAllowed){
      this.itemService.getStyleGroups(JSON.parse(sessionStorage.defaultcollectionid)).subscribe(data => {
        this.itemService.styleGroup.next(data.data);
      });
      const dialogSubscription = this.dialog.open(CreateNewItemComponent, { minWidth: '650px' }).afterClosed().subscribe(result => {
        this.getItemsInCollection();
        dialogSubscription.unsubscribe();
      });
    }
  }

  addMultipleItems() {
    if(this.roleSer.accessData && this.roleSer.accessData.insertAllowed || this.roleSer.accessData.updateAllowed){
      this.router.navigate(["uploaditems"], { relativeTo: this.activatedRoute });
    }
  }

  itemFilter(): void {
    this.isSearched = true;
    this.itemFilterSubscription = this.itemService.getItemFilter({
      collectionuuid: this.globalCollectionUUID,
      itemName: this.itemName ? encodeURIComponent(this.itemName) : '',
      itemDescription: this.itemDescription ? encodeURIComponent(this.itemDescription) : '',
      tag: this.tag ? encodeURIComponent(this.tag) : '',
      itemStatus: this.itemStatus
    })?.subscribe(
      (resData) => {
        this.items = resData?.data;
        this.isNoItems = !this.items || this.items.length === 0;
        this.items.sort((a, b) => new Date(b.updated).getTime() - new Date(a.updated).getTime());
        this.items.forEach(d => { d.questionTypes = d.questionTypes != null ? d.questionTypes[0].replaceAll(/\r/g, ' '): ''})
        this.items = new MatTableDataSource(this.items);
        this.setPaginator();
      }, (error: any) => {
        this.webErrorService.handleAPIErrors(error);
      });
    // this.isNoItems = true;
  }

  // dateSort(): void {
  //   this.isItemDescended = !this.isItemDescended;
  //   this.items.sort((a: any, b: any) => new Date(a.updated).getTime() - new Date(b.updated).getTime());
  // }

  resetFilter() {
    this.itemName = '';
    this.itemDescription = '';
    this.tag = '';
    this.itemStatus = 0;
    this.isSearched = false;
    this.itemSubscription = this.itemService.getItem(JSON.parse(sessionStorage.defaultcollectionuuid))?.subscribe(
      (resData) => {
        this.items = resData?.data;
        this.isNoItems = !this.items || this.items.length === 0;
        this.items.sort((a, b) => new Date(b.updated).getTime() - new Date(a.updated).getTime());
        this.items.forEach(d => { d.questionTypes = d.questionTypes != null ? d.questionTypes[0].replaceAll(/\r/g, ' '): ''})

        this.items = new MatTableDataSource(this.items);
        this.setPaginator();
      },
      (error) => this.router.navigate(["/login"]),
      () => { }) || undefined;
  }

  navigateToItemDetails(id: any, itemBankId: any, row: any) {
    sessionStorage.setItem("itemId", itemBankId);
    sessionStorage.setItem("itemuuidId", id);
    sessionStorage.setItem("scoringTypeId", row.scoringTypeId);
    // this.itemService.itemDetails.next(row);//commented because of multiple api calls
    this.router.navigate(["../items", id], { relativeTo: this.activatedRoute });
  }

  navigateToCreateNewItem(): void {
    this.router.navigate(["../create-new-item"], { relativeTo: this.activatedRoute });
  }

  ngOnDestroy() {
    if (this.itemSubscription) { this.itemSubscription.unsubscribe(); }
    if (this.itemFilterSubscription) { this.itemFilterSubscription.unsubscribe(); }
    if (this.activeRouteSubscription) { this.activeRouteSubscription.unsubscribe(); }
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  deleteItem(row) {
    const dialogRef = this.dialog.open(DelMessageComponent, {
      data: {
        message: this.translate.instant('items.deletePopup.message'),
        buttonText: {
          ok: this.translate.instant('items.deletePopup.btnYes'),
          cancel: this.translate.instant('items.deletePopup.btnNo')
        } } });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.itemService.deleteItem(row.itemuuid).subscribe((item: any) => {
          if(item.success) {
            this.notificationSer.success(item.message);
            this.getItemsInCollection();
          }
        }, (error) => {
          this.webErrorService.handleAPIErrors(error, null, true, 'warn');
        });
      }
    });
  }
}




